import Vue from 'vue'
import moment from 'moment';

let mutations = {
    left_menu(state, option) {
        if (option == "open") {
            state.left_open = true
        } else if (option == "close") {
            state.left_open = false
        } else if (option == "toggle") {
            state.left_open = !state.left_open
        }
        if (state.left_open) {
            document.getElementsByTagName("body")[0].classList.remove("left-hidden")
        } else {
            document.getElementsByTagName("body")[0].classList.add("left-hidden")
        }
    },
    routeChange(state, loader) {
        if (loader == "start") {
            state.preloader = true
        } else if (loader == "end") {
            state.preloader = false
        }
    },
    changePageTitle(state, title) {
        state.page_title = title
        document.title = title + " - " +state.site_name
    },
    addevent(state, event) {
        let id = state.cal_events[state.cal_events.length - 1] ? state.cal_events[state.cal_events.length - 1].id + 1 : 0;
        state.cal_events.push({ id: id, title: event.evtname, start: event.date.from, end: event.date.to })
    },
    editevent(state, event) {
        let evt = JSON.parse(JSON.stringify(event));
        let id_index = "";
        state.cal_events.forEach(function(currentValue, index) {
            if (currentValue.id == evt.id) {
                id_index = index;
            }
        });
        state.cal_events[id_index].title = evt.title;
        state.cal_events[id_index].start = evt.start;
        state.cal_events[id_index].end = evt.end;
    },
    removeevent(state, id) {
        let id_index = "";
        state.cal_events.forEach(function(currentValue, index) {
            if (currentValue.id == id.evtid) {
                id_index = index;
            }
        });
        state.cal_events.splice(id_index, 1);
    },
    forceLogout(state) {
        sessionStorage.removeItem('jwt');
        sessionStorage.clear();
        localStorage.removeItem('rememberToken');

        state.user = false;
    },
    SET_CONSTANTS(state, value) {
        // let types = value.role_types;
        // let i = 0;
        // let roleTypes = [];

        // for (var key in types) {
        //     roleTypes[i] = {'name': types[key].name, 'type':types[key].type};
        //     i++;
        // }

        // value.role_types = roleTypes;

        // console.log(roleTypes)
        //state.constants = (value);
        state.constants = {...state.constants, ...(value)};
    },
    SET_LANGUAGE(state, value) {
        state.language = value;
        // Vue.i18n.set(value);
        // moment.locale(value);
    },
    SET_BACKURL(state, value) {
        state.go_back_url = value;
    },
    SET_KEY(state, value) {
        state.key = value;
    },
    SET_BACKDATA(state, value) {
        state.go_back_data = value;
    },
    SET_CAMEFROM(state, value) {
        state.came_from_url = value;
    },

    /* T77 */
    SET_BACKURL_LIST(state, value) {
        state.go_back_url_list[value.key] = value.value;
    },
    SET_BACKDATA_LIST(state, value) {
        state.go_back_data_list[value.key] = value.value;
    },
    /*
    SET_USER_ROLES(state, value) {
        state.userCompanyRoles = (value);
    },
    */
    SET_USER_SELECTED_COMPANY(state, value) {
        state.userSelectedRole = (value);
    },
    SET_AJAX_IN_PROGRESS(state, value) {
        state.ajax_in_progress = (value);
    },
    SET_USER_PROJECTS(state, value) {
        state.menu_projects = (value);
    },
    SET_CURRENT_PROJECT(state, value) {
        state.current_project = (value);
    },
    SET_CURRENT_ISO(state, value) {
        state.current_iso = (value);
    },
    SET_CURRENT_COMPANY(state, value) {
        state.current_company = (value);
    },
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js